import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const UserTableRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: theme.spacing(0, 3),
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        removeUserButton: {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
            color: theme.palette.text.disabled,
            "&:hover": {
                color: theme.palette.error.main,
            },
        },
        toggleCloseBtn: {
            marginLeft: "auto",
            "& .MuiSvgIcon-root": {
                fontSize: 10,
                color: theme.palette.neutrals.dark,
            },
        },
        paceInfoPopper: {
            maxWith: "auto",
        },
        paceInfoWrapper: {
            maxWidth: 350,
        },
        paceInfoInner: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            marginBottom: theme.spacing(1),
        },
        paceInfoDescription: {
            fontSize: 14,
            fontWeight: 600,
            paddingRight: theme.spacing(1),
        },
        paceInfoCloseButton: {
            color: theme.palette.common.white,
            "& .MuiSvgIcon-root": {
                fontSize: 12,
            },
        },
        paceInfoRequestDataButton: {
            backgroundColor: "#F9FAFB",
            minWidth: "auto",
            height: 42,
        },
    })
);

export default UserTableRowStyles;
